module.exports = __webpack_public_path__ + "img/settings-1_640.376b5684.jpg";